module.exports = __webpack_public_path__ + "media/react/assets/TimeLeft-c0cb1f3c8c62e55deb594e66d96c45ad.svg";